:root {
  /* 'EmojiMart' represents the general emoji font of the app, themes may redefine it */
  --emojifonts: "EmojiMart", "Apple Color Emoji", NotoEmoji;
  --fonts-default:
    Roboto, var(--emojifonts), "Helvetica Neue", Arial, Helvetica, NotoMono,
    sans-serif;
  --fonts-system: system-ui, var(--fonts-default);
}

/* Theming Colors */
.avatar {
  --local-avatar-size: 48px;
  --local-avatar-vertical-margin: 8px;
  --local-avatar-font-size: 26px;
  display: inline-block;
  font-weight: normal;
  height: var(--local-avatar-size);
  margin: var(--local-avatar-vertical-margin) 0;
  position: relative;
  user-select: none;
  width: var(--local-avatar-size);
}
.avatar div.content,
.avatar img.content {
  height: var(--local-avatar-size);
  width: var(--local-avatar-size);
  border-radius: 100%;
  pointer-events: none;
}
.avatar div.content {
  background-color: #505050;
  color: var(--avatarLabelColor);
  font-size: var(--local-avatar-font-size);
  line-height: var(--local-avatar-size);
  object-fit: cover;
  text-align: center;
}
.avatar img.content {
  object-fit: cover;
}

.accountListSidebar {
  background-color: var(--accountSidebarBg);
  display: flex;
  flex-direction: column;
  min-width: 76px;
  overflow: hidden;
  padding-top: 4px;
}
.accountListSidebar .accountListNav {
  flex-grow: 1;
  overflow-y: scroll;
  scrollbar-width: none;
}
.accountListSidebar .accountListNav::-webkit-scrollbar {
  width: 0;
}
.accountListSidebar .accountListNav .accountList {
  --als-avatar-size: 48px;
  --als-avatar-margin: 7px;
  --als-active-indicator-color: white;
  margin: 0;
  padding: 0;
  list-style: none;
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-top: 2px;
}
.accountListSidebar .accountListNav .accountList li:has(.accountWrapper.isSticky) {
  position: sticky;
  bottom: 0;
  top: 0;
  z-index: 1;
}
.accountListSidebar .accountWrapper {
  margin-bottom: var(--als-avatar-margin);
  margin-top: var(--als-avatar-margin);
}
.accountListSidebar .accountWrapper.isSticky .account .avatar {
  opacity: 1;
}
.accountListSidebar .accountWrapper.isSticky .account .avatar .content {
  box-shadow: 0px 0px 4px 2px rgba(0, 0, 0, 0.2509803922);
}
.accountListSidebar .account {
  display: block;
  border: none;
  background: none;
  padding: 0;
  text-align: start;
  height: var(--als-avatar-size);
  scroll-margin-bottom: calc(3 * var(--als-avatar-margin) + var(--als-avatar-size));
  scroll-margin-top: calc(3 * var(--als-avatar-margin) + var(--als-avatar-size));
  position: relative;
  z-index: 0;
}
.accountListSidebar .account .avatar {
  --local-avatar-size: var(--als-avatar-size);
  --local-avatar-vertical-margin: 0;
  opacity: 0.7;
  transition: opacity ease-in 200ms;
}
.accountListSidebar .account .avatar div.content,
.accountListSidebar .account .avatar img.content {
  border-radius: 10%;
}
.accountListSidebar .account.active .avatar::before, .accountListSidebar .account:hover .avatar::before, .accountListSidebar .account.context-menu-active .avatar::before {
  --als-active-indicator-height: 15px;
  background: var(--als-active-indicator-color);
  border-radius: 20px;
  content: " ";
  height: var(--als-active-indicator-height);
  margin-inline-start: -18px;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  top: calc(var(--als-avatar-size) / 2 - var(--als-active-indicator-height) / 2);
  width: 10px;
}
.accountListSidebar .account.active .avatar, .accountListSidebar .account:hover .avatar, .accountListSidebar .account.context-menu-active .avatar {
  opacity: 1;
}
.accountListSidebar .account.active .avatar::before, .accountListSidebar .account.context-menu-active .avatar::before {
  --als-active-indicator-height: 36px;
}
.accountListSidebar .account.contextMenuActive .avatar::before {
  --als-active-indicator-height: 10px;
  opacity: 0.7;
}
.accountListSidebar .addButton {
  background: none;
  border-radius: 10%;
  border: 1.3pt solid var(--accountSidebarIconColor);
  color: var(--accountSidebarIconColor);
  font-size: 22px;
  margin-bottom: var(--als-avatar-margin);
  margin-top: var(--als-avatar-margin);
  min-height: var(--als-avatar-size);
  min-width: var(--als-avatar-size);
}
.accountListSidebar .addButton:hover {
  color: var(--accountSidebarBg);
  background: var(--accountSidebarIconColorHover);
  opacity: 0.7;
}
.accountListSidebar .settingsButton {
  background-color: transparent;
  border: 0;
  height: 42px;
  margin: 0;
  padding: 0;
  width: 42px;
}
.accountListSidebar .settingsButton .settingsButtonIcon {
  background-color: var(--accountSidebarIconColor);
}
.accountListSidebar .settingsButton:hover .settingsButtonIcon {
  background-color: var(--accountSidebarIconColorHover);
}

.macOSTrafficLightBackground {
  height: 30px;
  flex-shrink: 0;
  margin-bottom: -10px;
}

.buttonsContainer {
  align-items: center;
  border-top: 1px var(--accountSidebarInnerBorderColor) solid;
  display: flex;
  flex-direction: column;
  padding: 8px 0;
}

.accountBadge {
  bottom: -6px;
  pointer-events: none;
  position: absolute;
  inset-inline-end: -5px;
  z-index: 1;
}

.accountBadgeIcon {
  background-color: var(--unreadCountBg);
  border-radius: 10px;
  color: var(--unreadCountLabel);
  font-size: 9pt;
  font-weight: bold;
  height: 18px;
  line-height: 18px;
  padding: 0 4pt;
  text-align: center;
}
.accountBadgeIcon.bgSyncDisabled {
  background-color: grey;
  padding: 0 3pt;
}
.accountBadgeIcon.muted {
  background-color: grey;
}

.accountMutedIconShadow {
  filter: drop-shadow(0 0 2px black);
  inset-inline-start: 2px;
  pointer-events: none;
  position: absolute;
  top: 2px;
}

.accountMutedIcon {
  background-color: white;
}

.accountHoverInfoContainer {
  position: absolute;
  z-index: 200;
}

.accountHoverInfo {
  background-color: rgb(22, 22, 22);
  border-radius: 4px;
  color: white;
  display: flex;
  flex-direction: column;
  left: 60px;
  padding: 8px;
  top: var(--als-avatar-margin);
}

.hoverInfoProperty {
  font-size: smaller;
  color: rgb(180, 180, 180);
}

.connectivityDot {
  background-color: lightgray;
  border-radius: 100%;
  display: inline-block;
  line-height: 1em;
  margin-inline: 0.15em;
  min-height: 0.7em;
  min-width: 0.7em;
}

.hoverInfoMuteIcon {
  background-color: white;
  position: relative;
  top: 2px;
}

.hoverInfoDisabledIcon {
  display: inline-block;
  text-align: center;
  width: 1em;
}

.dragging {
  opacity: 0.5;
  transform: scale(0.95);
  transition: all 0.2s ease;
}

.dragOverTop,
.dragOverBottom {
  position: relative;
}
.dragOverTop::before,
.dragOverBottom::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background-color: var(--colorPrimary);
  z-index: 10;
  border-radius: 1px;
}

.dragOverTop::before {
  top: -2px;
}

.dragOverBottom::before {
  bottom: -2px;
}